import Icon from '../components/Icon.vue'

Icon.register({
  atlas: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M318.4 208H279.3C277.8 235 272.8 259.4 265.1 278.4 292.8 265.2 313.1 239.2 318.4 208zM318.4 176C313.1 144.8 292.8 118.8 265.1 105.6 272.8 124.6 277.8 149 279.3 176H318.4zM224 97.3C216.3 104.8 203.2 131.7 200.6 176H247.4C244.8 131.7 231.7 104.8 224 97.3zM182.9 105.6C155.2 118.8 134.9 144.8 129.6 176H168.7C170.2 149 175.2 124.6 182.9 105.6zM182.9 278.4C175.2 259.4 170.2 235 168.7 208H129.6C134.9 239.2 155.2 265.2 182.9 278.4zM247.4 208H200.6C203.2 252.3 216.3 279.2 224 286.7 231.7 279.2 244.8 252.3 247.4 208zM448 358.4V25.6C448 9.6 438.4 0 422.4 0H96C41.6 0 0 41.6 0 96V416C0 470.4 41.6 512 96 512H422.4C435.2 512 448 502.4 448 486.4V470.4C448 464 444.8 457.6 438.4 451.2 435.2 435.2 435.2 390.4 438.4 377.6 444.8 374.4 448 368 448 358.4zM224 64C294.7 64 352 121.3 352 192S294.7 320 224 320 96 262.7 96 192 153.3 64 224 64zM384 448H96C76.8 448 64 435.2 64 416S80 384 96 384H384V448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/atlas.js
// module id = E0qe
// module chunks = 144